import { FEATURE_NAMES as V2_FEATURE_NAMES, toFeatureVector as toV2FeatureVector, } from '../v2/features.js';
/** Fixed order for one-hot encoding `MarketRegime` — must match `REGIME_NAMES` below positionally. */
const REGIME_ORDER = ['TREND', 'CHOP', 'BREAKOUT', 'VOLATILE'];
/**
 * V3's feature vector: V2's 18 OHLCV-derived features, plus two additions.
 * Order matters — positional, like V2 — so `toFeatureVector` and
 * `extendV2FeatureVector` must stay in lockstep with this list.
 */
export const FEATURE_NAMES = [
    ...V2_FEATURE_NAMES,
    'targetDistancePct',
    'targetDistanceAtr',
    'regimeTrend',
    'regimeChop',
    'regimeBreakout',
    'regimeVolatile',
];
function targetAndRegimeFeatures(signal, targetPrice) {
    const target = targetPrice ?? signal.roundOpenPrice;
    const targetDistancePct = signal.price
        ? ((signal.price - target) / signal.price) * 100
        : 0;
    const targetDistanceAtr = signal.atrPct ? targetDistancePct / signal.atrPct : 0;
    const regimeOneHot = REGIME_ORDER.map((regime) => (signal.regime === regime ? 1 : 0));
    return [targetDistancePct, targetDistanceAtr, ...regimeOneHot];
}
/** Builds a full V3 feature vector, in `FEATURE_NAMES` order, from raw signal inputs. */
export function toFeatureVector(inputs) {
    const v2Vector = toV2FeatureVector(inputs);
    return [...v2Vector, ...targetAndRegimeFeatures(inputs.signal, inputs.targetPrice)];
}
/**
 * Extends an already-computed V2 feature vector (e.g. `BacktestSample.features`
 * from `v2.replayRounds`) with V3's target-distance and regime features,
 * without recomputing MACD — V2's vector already encodes it via
 * `macdHistPct`, so nothing here needs it again.
 */
export function extendV2FeatureVector(v2Vector, signal, targetPrice) {
    return [...v2Vector, ...targetAndRegimeFeatures(signal, targetPrice)];
}
//# sourceMappingURL=features.js.map